import React from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Container,
  Dropdown,
  Menu,
  Button,
  Modal,
  Popup
} from 'semantic-ui-react';
import { buildDisplayTime } from '../../state/jobs/time-utils';
import { viewTimezoneOptions } from '../../utils';
import { push } from 'react-router-redux';
import { deleteJob } from '../../state/jobs/actions';
import { Loading } from '../layout/loading';

const JobsList = React.createClass({
  getInitialState() {
    return {
      displayTimezone: 'US/Eastern',
      open: false,
      id: null
    };
  },
  show(id) {
    return this.setState({
      open: true,
      id: id
    });
  },

  close() {
    return this.setState({
      open: false,
      id: null
    });
  },

  delete(id) {
    this.props.handleDelete(id);
    this.close();
  },

  showJobs(jobs, timezone) {
    return jobs.map(job => {
      const isDisabled =
        job.get('status') === 'Interpreters applied to job' ||
        job.get('status') === 'Assigned to interpreter';

      const id = job.get('id');

      // Removes case where None is displayed as a default value
      const fullLocationDisplay = job
        .get('full_location_display')
        .replace(' None,', ' ,')
        .replace(' , ', ', ');
      // dynamically converts time shown based on selected timezone
      const startTimeUTC = job.get('start_time_utc');
      const startDisplay = buildDisplayTime(startTimeUTC, timezone);

      return (
        <Table.Row key={id}>
          <Table.Cell>{job.get('case_name')}</Table.Cell>
          <Table.Cell>{job.get('claim_number')}</Table.Cell>
          <Table.Cell>{job.get('job_type')}</Table.Cell>
          <Table.Cell>{job.get('status')}</Table.Cell>
          <Table.Cell>{fullLocationDisplay}</Table.Cell>
          <Table.Cell>{job.get('site_name')}</Table.Cell>
          <Table.Cell>{startDisplay}</Table.Cell>
          <Table.Cell>{job.get('language')}</Table.Cell>
          <Table.Cell>
            <Button onClick={() => this.props.handleEdit(id)}> Edit</Button>
          </Table.Cell>
          <Table.Cell>
            {isDisabled ? (
              <Popup
                trigger={<Button content="Delete" />}
                content="This job has been applied to by an interpreter and cannot be deleted. Please contact fernando@nuancedinterpretation.com"
                on="click"
              />
            ) : (
              <Button onClick={() => this.show(id)}>Delete</Button>
            )}
          </Table.Cell>
        </Table.Row>
      );
    });
  },

  render() {
    const { jobs, isLoading } = this.props;
    const { displayTimezone, open, id } = this.state;
    const jobsList = this.showJobs(jobs, displayTimezone);
    return isLoading ? (
      <Loading />
    ) : jobsList.size ? (
      <Container>
        <Modal open={open} onClose={this.close}>
          <Modal.Content>
            <Modal.Description>
              <p>Deleting this job is an action that cannot be undone</p>
              <p>Are you sure you want to delete it?</p>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={this.close}>
              No
            </Button>
            <Button
              positive
              icon="checkmark"
              labelPosition="right"
              content="Yes, I want to delete this job"
              onClick={() => this.delete(id)}
            />
          </Modal.Actions>
        </Modal>
        <Menu compact>
          <Dropdown
            search
            scrolling
            selection
            value={displayTimezone}
            options={viewTimezoneOptions}
            item
            onChange={(e, data) =>
              this.setState({ displayTimezone: data.value })
            }
          />
        </Menu>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell> Case </Table.HeaderCell>
              <Table.HeaderCell> Claim Number </Table.HeaderCell>
              <Table.HeaderCell> Job Type </Table.HeaderCell>
              <Table.HeaderCell> Status </Table.HeaderCell>
              <Table.HeaderCell> Address </Table.HeaderCell>
              <Table.HeaderCell> Site Name </Table.HeaderCell>
              <Table.HeaderCell> Start Time </Table.HeaderCell>
              <Table.HeaderCell> Language </Table.HeaderCell>
              <Table.HeaderCell> </Table.HeaderCell>
              <Table.HeaderCell> </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{jobsList}</Table.Body>
        </Table>
      </Container>
    ) : (
      <Container className="job-placeholder">
        You have not created any jobs yet. Please click 'Create Job' in the
        header or sidebar.
      </Container>
    );
  }
});

const mapStateToProps = state => ({
  isLoading: state.jobs.get('isLoading')
});

const mapDispatchToProps = dispatch => ({
  handleEdit: id => {
    dispatch(push(`/jobs/${id}`));
  },
  handleDelete: id => {
    dispatch(deleteJob(id));
  }
});

export const JobsListContainer = connect(mapStateToProps, mapDispatchToProps)(
  JobsList
);



/** WEBPACK FOOTER **
 ** ./src/components/jobs/job-list.jsx
 **/